// @ts-nocheck
import React, { useEffect, useState, useCallback, useId } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Divider, styled } from '@mui/material';
import Paper from '@mui/material/Paper';
import { useLocation, useNavigate } from 'react-router-dom';
import ProxyBidModal from './UpdateProxyBidModal';
import { useAuth } from '../services/AuthContext';
import { getInvestorApiUrl, getInvestorAuctionerUrl } from '../utils/config';
import NumberFormatter from '../utils/NumberFormater';
import { FundsHeader } from '../components/commonComponents/FundsHeader';
import { useSignalR } from '../services/context/SignalRContext';
import { useDispatch, useSelector } from 'react-redux';
import { MyBidApi, removeExcludedId } from '../redux/slice/mybidSlice';
import Loading from '../components/Loading';
import moment from 'moment';
import { fetchStates } from '../redux/slice/countyStateSlice';
import { Helmet } from 'react-helmet';
import { BackButton } from '../components/commonComponents/BackButton';
import { useMediaQuery, useTheme } from '@mui/material';
import { Grid } from '@mui/material';
import { AppDispatch, RootState } from '@/redux/store';
const MyBids = () => {
  const { pathname } = useLocation()
  const [activeTab, setActiveTab] = useState('today');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [funds, setFunds] = useState(null);
  const [selectedAuctionId, setSelectedAuctionId] = useState(null);
  const [auctionReservePrice, setAuctionReservePrice] = useState(null)
  const [loading, setLoading] = useState(false);
  const [loadingTimer, setLoadingTimer] = useState(true);  // Track loading state
  const [message, setMessage] = useState({});
  const [highlightedRows, setHighlightedRows] = useState([]);
  const [countdowns, setCountdowns] = useState({});
  const { investorId } = useSelector((state: RootState) => state?.user);
  const purchaseProfiles = useSelector((state: RootState) => state?.purchaseProfile?.profiles?.body || [])
  const auctions = useSelector((state: RootState) => state?.mybid?.myBidData?.data || [])
  const apiloading = useSelector((state: RootState) => state?.mybid?.loading);
  const dispatch = useDispatch<AppDispatch>();

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: "#FCFCFC",
      border: "1px solid #C5C9CD",
    },
    '&:nth-of-type(odd)': {
      border: 0,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  const { connection } = useSignalR();

  const [state, setState] = useState({
    auctionList: []
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchMyBids = async () => {
      try {
        if (investorId) {
          await dispatch(MyBidApi(parseInt(investorId))).unwrap();
        }
      } catch (error) {
        console.error('Failed to fetch bids:', error);
      }
    };

    fetchMyBids();
  }, [investorId, dispatch]);

  useEffect(() => {
    const fetchAllStates = async () => {
      setLoading(true);
      try {
        await dispatch(fetchStates()).unwrap();
      } catch (error) {
        console.error(error);
      }
    };

    fetchAllStates();
  }, [dispatch]);

  const messageData = {
    highestbid: 'You are the highest bidder',
    outbid: "You have been outbid!",
    thirdParty: 'Auction Ended - Sold to third party',
    youwon: 'Auction Ended - You Won',
    soldtobank: 'Auction Ended - Sold to Bank'
  }
  const getAuctionMessage = (data, investorId, messageData, purchaseProfiles) => {
    const {
      highestBidderId,
      lastOutBiddedId,
      auctionResult,
      winnerInvestorId,
      auctionStatus
    } = data || {};

    console.log(purchaseProfiles, 'WinnerInvestorId')
    Array.isArray(purchaseProfiles) && purchaseProfiles.some(profile => console.log(profile.InvestorId,  winnerInvestorId, 'investorId'))

    if (
      winnerInvestorId === investorId ||
      (Array.isArray(purchaseProfiles) && purchaseProfiles.some(profile => profile.investorId === winnerInvestorId))
    ) {
      return messageData?.youwon;
    }
    if (highestBidderId == investorId && auctionStatus == 'Live') return messageData?.highestbid;
    if (lastOutBiddedId == investorId) return messageData?.outbid;
    if (auctionResult === "FCLT_Sold3rdParty" && auctionStatus === "Closed") return messageData?.thirdParty;
    if (auctionResult === "FCLT_SoldBank" && auctionStatus === "Closed") return messageData?.soldtobank;

    return "";
  };
  useEffect(() => {
    if (connection && auctions?.Today?.length > 0) {
      auctions.Today.forEach((auction) => {
        const id = auction.id; // or auction.id depending on your structure
        connection.on(`ReceiveAllResponse${id}`, (msg, time, beaconResponse) => {
          console.log(beaconResponse, "beacon response for id", id)
          setMessage((prev) => ({
            ...prev,
            [id]: {
              message: getAuctionMessage(beaconResponse?.data, investorId, messageData, purchaseProfiles),
              userid: beaconResponse?.data?.userId,
              highestBidderId: beaconResponse?.data?.highestBidderId,
              currentHighestBid: beaconResponse?.data?.currentHighestBid,
              lastOutBiddedId: beaconResponse?.data?.lastOutBiddedId,
              newAskAmount: beaconResponse?.data?.newAskAmount,
              auctionResult: beaconResponse?.data?.auctionResult,
              auctionStatus: beaconResponse?.data?.auctionStatus,
              auctionRedoStatus: beaconResponse?.data?.auctionRedoStatus || 0
            },
          }));
        });
      });

      connection.on(`ReceiveWalletBalance${parseInt(investorId)}`, (fundsData) => {
        setFunds(fundsData);
        console.info(fundsData, 'wallet balance data');
      });

      connection.on('UserJoined', (user, groupname) => {
        console.log(user, groupname, 'user joined');
      });

      // Cleanup listeners
      return () => {

        auctions?.Today?.length > 0 && auctions.Today.forEach((auction) => {
          connection.off(`ReceiveAllResponse${auction.auctionId}`);
        });
        connection.off(`ReceiveWalletBalance${parseInt(investorId)}`);
        connection.off('UserJoined');
      };
    }
  }, [connection, auctions, investorId, funds, pathname, purchaseProfiles]);

  const attemptReconnect = async (retryCount = 0, maxRetries = 5) => {
    if (!connection) {
      console.log('No connection instance available');
      return;
    }

    try {
      if (connection.state === 'Disconnected') {
        console.log(`Attempting to reconnect... (Attempt ${retryCount + 1}/${maxRetries})`);

        // Stop the existing connection first
        await connection.stop();

        // Start a new connection
        await connection.start();
        console.log('Connection reestablished');

        // Only attempt to join group if connection is successful
        if (connection.state === 'Connected') {
          await JoinGroups();
        }
      }
    } catch (err) {
      console.error("Reconnection failed:", err);

      if (retryCount < maxRetries) {
        const delay = Math.min(1000 * Math.pow(2, retryCount), 30000);
        console.log(`Retrying in ${delay / 1000} seconds...`);
        setTimeout(() => attemptReconnect(retryCount + 1, maxRetries), delay);
      } else {
        console.error("Max retry attempts reached");
      }
    }
  };

  const JoinGroups = useCallback(async () => {
    if (connection) {
      try {
        // Map through all auctions and create an array of promises
        const joinPromises = auctions?.Today?.map((auction) => {
          connection.invoke('JoinGroup', `${auction.id}`, `${investorId}`)
          console.log(auction.id, 'auction.id');
        }
        );
        // Wait for all join operations to complete
        await Promise.all(joinPromises);
      } catch (error) {
        console.error('Error joining groups:', error);
      }
    }
  }, [auctions, connection]);
  useEffect(() => {


    JoinGroups();

  }, [connection, auctions]);

  const fetchData = async () => {
    if (connection) {
      await connection.invoke('GetWalletBalance', parseInt(investorId));
    }
  }
  const updateCountdowns = useCallback(() => {
    const newCountdowns = {};

    auctions?.Today?.forEach((auction) => {
      // Parse the auction's opening date using moment.parseZone to handle any time zone info
      const openingDate = moment.parseZone(auction.srpSaleDateTime).valueOf();  // Convert to milliseconds

      // Get the current time in milliseconds
      const currentTime = moment().valueOf();  // current time in milliseconds

      // Calculate the countdown for each auction
      newCountdowns[auction.id] = openingDate > currentTime ? openingDate - currentTime : 0;
    });

    setCountdowns(newCountdowns);
    setLoadingTimer(false);  // Set loading to false once countdowns are updated
  }, [auctions])

  useEffect(() => {
    // Fetch auction data and wallet balance efficiently
    fetchData();

    // Update countdown immediately on mount
    updateCountdowns();

    // Set interval to update countdown every second
    const intervalId = setInterval(() => {
      updateCountdowns();
    }, 1000);


    if (!auctions?.Today || !Array.isArray(auctions.Today)) return;
    auctions.Today.forEach((auction) => {
      const id = auction.id;
      setMessage((prev) => ({
        ...prev,
        [id]: {
          message: getAuctionMessage(auction, investorId, messageData, purchaseProfiles),
          userid: auction?.userId,
          currentHighestBid: auction?.currentHighestBid,
          lastOutBiddedId: auction?.lastOutBiddedId,
          highestBidderId: auction?.highestBidderId,
          newAskAmount: auction?.newAskAmount,
          auctionResult: auction?.auctionResult || "",
          auctionStatus: auction?.auctionStatus || "",
          auctionRedoStatus: auction?.auctionRedoStatus || 0
        },
      }));
    });

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [auctions, investorId, purchaseProfiles]);


  const formatCountdown = (time) => {
    const hours = Math.floor(time / (1000 * 60 * 60));
    const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((time % (1000 * 60)) / 1000);
    return `${hours}h ${minutes}m ${seconds}s`;
  };

  // Toggle modal
  const toggleModal = useCallback((open) => {
    setIsModalOpen(open);
  }, []);



  useEffect(() => {
    const timer = setTimeout(() => {
      setHighlightedRows([]); // Remove highlights after 3 seconds
    }, 3000);

    return () => clearTimeout(timer); // Cleanup the timer
  }, [highlightedRows]);

  const handleHighlight = () => {
    const highlightedIds = [];
    Object.keys(auctions)
      .filter((key) => key !== 'Closed')
      .forEach((key) => {
        auctions[key].forEach((row) => {
          // Highlight condition: proxyAddedDate within 12 seconds
          const proxyAddedDateUTC = new Date(row.proxyAddedDate);
          const proxyAddedDateLocal = new Date(
            proxyAddedDateUTC.getTime() - proxyAddedDateUTC.getTimezoneOffset() * 60000
          );
          const currentLocalTime = new Date();
          const timeDifference = currentLocalTime - proxyAddedDateLocal;

          if (timeDifference >= 0 && timeDifference <= 12000) {
            highlightedIds.push(row.id);
          }
        });
      });

    setHighlightedRows(highlightedIds);
  };

  // Call handleHighlight on mount and data fetch
  useEffect(() => {
    handleHighlight();
  }, [auctions]);


  // Navigate to live auction page
  const handleNavigate = ((id) => {
    dispatch(removeExcludedId(id))
    navigate(`/liveauction/${id}`)
  });

  const handleSearchNavigate = () => {
    navigate('/search')
  }


  const [sortDirection, setSortDirection] = useState('ascending');

  const handleSort = () => {
    setSortDirection(current => current === 'ascending' ? 'descending' : 'ascending');
  };

  const getSortedData = (data) => {
    const sortedData = { ...data };
    Object.keys(sortedData)
      .filter(key => key !== 'Today' && key !== 'Closed')
      .forEach(key => {
        sortedData[key] = [...data[key]].sort((a, b) => {
          return sortDirection === 'ascending'
            ? new Date(a.openingDate) - new Date(b.openingDate)
            : new Date(b.openingDate) - new Date(a.openingDate);
        });
      });
    return sortedData;
  };

  function getTotalLength(data) {
    let totalLength = 0;

    // Sum lengths of the relevant arrays
    totalLength += data?.Tomorrow?.length || 0;
    totalLength += data["Next Week"]?.length || 0;
    totalLength += data["Next Month"]?.length || 0;
    totalLength += data?.Upcoming?.length || 0;

    return totalLength;
  }

  return (
    apiloading ? <Loading /> :
      <>
        <div className='flex justify-start items-center'>
        </div>
        <div className='w-full justify-center m-auto flex flex-col lg:flex-row '>

          <Helmet>
            <title>xBid | My Bids</title>
            <meta name="description" content="View and manage your proxy bids for upcoming auctions. Track live auctions and update your bids in real-time." />
          </Helmet>
          {/* Sidebar */}
          {/* <div className='w-full lg:w-1/6 h-screen bg-slate-300'>Sidebar</div> */}
          <div className='w-full lg:w-full p-1 md:p-2 '>
            {/* Funds */}

            {isMobile ? (
              <>
                <FundsHeader funds={funds} isMyBidMobile={true} />
                <div className="w-full">
                  {/* Tab Buttons */}
                  <div className="flex mt-2 border">
                    <button
                      onClick={() => setActiveTab('today')}
                      className={`px-4 py-2 text-sm font-medium border-b-2 ${activeTab === 'today' ? 'border-[#FF5C39] text-gray-700' : 'text-gray-700'
                        }`}
                    >
                      Today's Auction
                    </button>
                    <button
                      onClick={() => setActiveTab('upcoming')}
                      className={`px-4 py-2 text-sm font-medium border-b-2 ${activeTab === 'upcoming' ? 'border-[#FF5C39] text-gray-700' : 'text-gray-700'
                        }`}
                    >
                      Upcoming Auctions
                    </button>
                  </div>

                  {/* Tab Content */}
                  {activeTab === 'today' && (
                    <div className='grid grid-cols-1 gap-5 pt-6'>
                      {auctions?.Today && auctions?.Today?.length > 0 && auctions?.Today?.some(auction => auction?.county) ? (
                        auctions?.Today
                          .filter((auction) => auction.status !== false)
                          .map((auction, index) => {
                            const isLiveOrPaused = message[auction.id]?.auctionStatus === "Pause" || message[auction.id]?.auctionStatus === "Live" || message[auction.id]?.auctionRedoStatus === 2;;
                            const isCountdownZero = countdowns[auction.id] === 0;
                            const isBelowReserve = auction.reservePrice != 0 && auction.proxyBidAmount < auction.reservePrice;
                            const hasPassedPreWindow = countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000;
                            const isAuctionNotLive = auction.auctionStatus !== "Live";
                            const baseClasses = 'p-2 rounded-md w-32 text-sm text-center flex justify-center cursor-pointer';
                            const buttonClassName =
                              isLiveOrPaused || isCountdownZero || (isBelowReserve && hasPassedPreWindow)
                                ? `${baseClasses} bg-[#FF5C39] text-white`
                                : (hasPassedPreWindow && isAuctionNotLive)
                                  ? `${baseClasses} bg-[#FFF] border border-[#FF5C39] text-[#FF5C39]`
                                  : 'p-2 bg-[#9FA4AB] rounded-[8px] w-32 text-white text-sm text-center flex justify-center';
                            return (
                              <div
                                key={index}
                                style={{ height: '100%' }}
                                className={`${highlightedRows.includes(auction.id)
                                  ? 'highlight-flip p-4 mb-4 w-full flex flex-col justify-between bg-white shadow-[0px_0px_8px_0px_#3B3B3B26]'
                                  : 'p-4 mb-4 w-full flex flex-col justify-between bg-white shadow-[0px_0px_8px_0px_#3B3B3B26]'
                                  }`}
                              >
                                <div>
                                  <div
                                    className='text-sm font-medium'
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap'
                                    }}
                                  >
                                    {auction.address}
                                  </div>
                                  <div className='text-sm flex justify-between items-center mt-2'>
                                    <div>Proxy Bid Placed: <strong className='text-darkGray'> $<NumberFormatter amount={auction.proxyBidAmount} /></strong></div>
                                    {(message[auction.id]?.auctionStatus === "Live" ||
                                      (countdowns[auction.id] === 0 && message[auction.id]?.auctionStatus !== "Closed")
                                    ) && (
                                        <div className='p-[4px] pr-1 border rounded-md bg-green-100 border-green-400 text-green-500 text-xs flex items-center'>
                                          <svg stroke="currentColor" fill="currentColor" aria-label="Live Auction" strokeWidth="0" viewBox="0 0 8 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" aria-label="Live auction in progress"><path fillRule="evenodd" d="M0 8c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4z"></path></svg> Live
                                        </div>
                                      )}
                                  </div>
                                </div>
                                <Divider sx={{ paddingTop: '6px' }} />
                                {

                                  (message[auction.id]?.auctionStatus == "Live" || countdowns[auction.id] === 0) ? (
                                    // ✅ LIVE BLOCK
                                    <>
                                      {
                                        (message[auction.id]?.auctionStatus == 'Live' || auction.auctionStatus == 'Live' || message[auction.id]?.auctionStatus === "Closed" || auction?.auctionStatus == "Closed") ? (
                                          <div className={`${message[auction.id]?.userid === investorId ? ' text-[#28A745]' : 'text-[#3B3B3B] '} text-center pt-3 font-semibold text-[28px]`}> {message[auction.id]?.currentHighestBid ? ` $${message[auction.id]?.currentHighestBid?.toLocaleString() || auction.currentHighestBid?.toLocaleString()}` : "-"}</div>
                                        ) :
                                          <div className='text-center pt-3 text-[#3B3B3B] font-semibold text-[28px]'> ${auction?.estOpeningBidAmount?.toLocaleString()}</div>
                                      }
                                      <div className='text-center text-[14px] font-semibold'>
                                        Current Highest Bid
                                      </div>
                                      {
                                        (!message[auction?.id]?.message || message[auction?.id]?.message === "") ? (
                                          <div className={"min-h-7"}>

                                          </div>
                                        ) : (
                                          <div className={`${(message[auction?.id]?.message === (messageData.thirdParty || messageData.soldtobank)) ? "text-[#3b3b3b]" : message[auction.id]?.lastOutBiddedId == investorId ? 'text-[#EF233C]' : 'text-[#28A745]'} bg-[#F8F8F8] p-2 rounded-md text-[16px] text-center`}>
                                            {message[auction?.id]?.message}
                                          </div>

                                        )
                                      }
                                    </>
                                  ) : message[auction.id]?.auctionStatus == "Closed" ? (
                                    // ✅ CLOSED BLOCK
                                    message[auction.id]?.auctionRedoStatus === 2 ?

                                      <div className='flex justify-center items-center text-center mt-7 mb-7 text-sm h-full' aria-live="polite">
                                        <div>
                                          Auction starts in
                                        </div>
                                        <div className='w-[90px]'>
                                          <strong className='ml-1'>0h 0m 0s</strong>
                                        </div>
                                      </div> :
                                      <>
                                        <div className='text-center pt-3 text-[#3B3B3B] font-semibold text-[28px]'> {message[auction.id]?.currentHighestBid ? ` $${message[auction.id]?.currentHighestBid?.toLocaleString() || auction.currentHighestBid?.toLocaleString()}` : message[auction?.id]?.auctionResult === "FCLT_SoldBank" ? `$${auction?.reservePrice?.toLocaleString()}`
                                          : "-"}</div>
                                        <div className='text-center text-[14px] font-semibold'>{message[auction?.id]?.auctionResult !== "FCLT_SoldBank" ? "Winning Bid" : ""}</div>
                                        {
                                          message[auction?.id]?.message ? (
                                            <div className={`${(message[auction?.id]?.message === (messageData.thirdParty || messageData.soldtobank)) ? "text-[#3b3b3b]" : message[auction.id]?.lastOutBiddedId == investorId ? 'text-[#EF233C]' : 'text-[#28A745]'} bg-[#F8F8F8] p-2 rounded-md text-[16px] text-center`}>
                                              {message[auction?.id]?.message}
                                            </div>
                                          ) : (
                                            <div className={"min-h-7"}>

                                            </div>
                                          )
                                        }
                                      </>
                                  ) : message[auction.id]?.auctionStatus == "Pause" ? (
                                    // ✅ PAUSED BLOCK
                                    <div className='flex justify-center items-center text-center mt-7 mb-7 text-sm h-full' aria-live="polite">
                                      <div>
                                        Auction starts in
                                      </div>
                                      <div className='w-[90px]'>
                                        <strong className='ml-1'>0h 0m 0s</strong>
                                      </div>
                                    </div>
                                  ) : (
                                    // ✅ DEFAULT COUNTDOWN BLOCK
                                    <div className='flex justify-center items-center text-center mt-7 mb-7 text-sm h-full' aria-live="polite">
                                      <div>
                                        Auction Starts in
                                      </div>
                                      <div className='w-[90px]'>
                                        <strong className='ml-1'>{formatCountdown(countdowns[auction.id])}</strong>
                                      </div>
                                    </div>
                                  )
                                }

                                {auction.reservePrice != 0 &&
                                  auction.proxyBidAmount < auction.reservePrice &&
                                  countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000 && (
                                    <div className='flex justify-center items-center bg-[#F8F8F8] p-2 rounded-md mb-2'>
                                      <span className="text-red-500 text-sm">Proxy bid less than reserve price </span>
                                    </div>
                                  )}
                                <div className='mt-auto flex justify-center items-center w-full'>
                                  {
                                    message[auction.id]?.auctionStatus !== "Closed" || message[auction.id]?.auctionRedoStatus === 2 ?
                                      <>
                                        <div
                                          onClick={() => {
                                            if (auction.reservePrice != 0 &&
                                              auction.proxyBidAmount < auction.reservePrice &&
                                              countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000) {
                                              setSelectedAuctionId(auction.id);
                                              setAuctionReservePrice(auction?.reservePrice)
                                              toggleModal(true);
                                            } else {
                                              if (countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000 && (message[auction.id]?.auctionStatus !== "Live" && message[auction.id]?.auctionStatus !== "Pause") && message[auction.id]?.auctionRedoStatus !== 2) {
                                                setSelectedAuctionId(auction.id);
                                                toggleModal(true);
                                                setAuctionReservePrice(auction?.reservePrice)
                                              }
                                              const isLive = message[auction.id]?.auctionStatus === "Live" || message[auction.id]?.auctionStatus === "Pause";
                                              const isCountdownFinished = countdowns[auction.id] === 0;

                                              if (isLive || isCountdownFinished || message[auction.id]?.auctionRedoStatus === 2) {
                                                handleNavigate(auction.id);
                                              }
                                            }
                                          }}
                                          className={buttonClassName}
                                        >
                                          {(countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000 && (message[auction.id]?.auctionStatus !== "Live" && message[auction.id]?.auctionStatus !== "Pause") && message[auction.id]?.auctionRedoStatus !== 2)
                                            ? (auction.reservePrice != 0 && auction.proxyBidAmount < auction.reservePrice)
                                              ? "Increase Bid"
                                              : "Update Bid"
                                            : "Live Auction"
                                          }
                                        </div>
                                      </> : (
                                        <div
                                          onClick={() => navigate(`/auctionpage/${auction?.propertyId}`)}
                                          className={'p-2 bg-[#FF5C39] rounded-md w-32 text-white text-sm text-center flex justify-center cursor-pointer'}
                                        >
                                          View Details
                                        </div>
                                      )
                                  }
                                </div>
                              </div>
                            )
                          })
                      ) : (
                        <div className="col-span-full bg-[#FCF8E3] p-3 flex justify-between items-center">
                          <div className='text-[#8A6D3B] text-[18px] font-[400]'>
                            You haven't placed any proxy bids yet. Start exploring properties and secure your opportunities to bid effortlessly.
                          </div>
                          <div className='text-[#FF5C39] text-[20px] cursor-pointer' aria-label="Search" onClick={() => handleSearchNavigate()}>
                            <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab === 'upcoming' && (
                    <>
                      <div className={getTotalLength(auctions) === 0 ? '' : 'bg-[#ffff] p-2 rounded shadow-custom-shadow-mybid'}>
                        {getTotalLength(auctions) === 0 ? (
                          <div className="col-span-full bg-[#FCF8E3] p-3 flex justify-between items-center">
                            <div className='text-[#8A6D3B] text-[18px] font-[400]'>
                              You haven't placed any proxy bids yet. Start exploring properties and secure your opportunities to bid effortlessly.
                            </div>
                            <div className='text-[#FF5C39] text-[20px] cursor-pointer' aria-label="Search" role="button" onClick={() => handleSearchNavigate()}>
                              <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                            </div>
                          </div>
                        ) : (
                          <>
                            {Object.keys(getSortedData(auctions))
                              .filter(key => key !== 'Today' && key !== 'Closed')
                              .map(key =>
                                getSortedData(auctions)[key].map((row, index) => {
                                  // Parse proxyAddedDate (in UTC)
                                  const proxyAddedDateUTC = new Date(row.proxyAddedDate);

                                  // Convert proxyAddedDate to local time
                                  const proxyAddedDateLocal = new Date(proxyAddedDateUTC.getTime() - proxyAddedDateUTC.getTimezoneOffset() * 60000);

                                  // Get current local time
                                  const currentLocalTime = new Date();

                                  // Calculate the time difference in milliseconds
                                  const timeDifference = currentLocalTime - proxyAddedDateLocal;

                                  // Check if the difference is <= 30 minutes (1,800,000 ms)
                                  const isHighlighted = timeDifference >= 0 && timeDifference <= 60000;

                                  return (
                                    <div className="border rounded py-2 my-2 px-2">
                                      <Grid sx={{ color: '#3B3B3B', fontWeight: 600, fontSize: '14px', }}>{row.address}</Grid>
                                      <Grid container spacing={2}>
                                        <Grid item xs={7}>
                                          {/* First Box */}
                                          <div className="">
                                            <Grid sx={{ color: '#3B3B3B', fontSize: '14px', pt: "5px" }}>
                                              {row.county}
                                            </Grid>
                                            <Grid sx={{ color: '#3B3B3B', fontSize: '14px', pt: "5px" }}>
                                              <span style={{ paddingRight: "22px" }}>  Reserve Price</span> <span style={{ fontWeight: '500' }}>${row.reservePrice?.toLocaleString()}</span>
                                            </Grid>
                                            <Grid sx={{ color: '#3B3B3B', fontSize: '14px', pt: "5px" }}>
                                              <span style={{ paddingRight: "2px" }}>Proxy Bid Placed </span> <span style={{ fontWeight: '500' }}>${row.proxyBidAmount?.toLocaleString()}</span>
                                            </Grid>
                                            <Grid>
                                              {row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice && (
                                                <span className="text-red-500 text-xs font-[600]">Proxy bid less than reserve price</span>
                                              )}
                                            </Grid>
                                          </div>
                                        </Grid>
                                        <Grid item xs={5}>
                                          {/* Second Box */}
                                          <div className="">
                                            <Grid sx={{ color: '#3B3B3B', fontSize: '14px', pt: "5px", textAlign: "right" }}>
                                              {new Date(row?.srpSaleDateTime?.replace(/([+-]\d{2}:\d{2})$/, ''))?.toLocaleString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: '2-digit',
                                              })}
                                            </Grid>
                                            <Grid sx={{ color: '#3B3B3B', fontSize: '14px', pt: "5px", textAlign: "right" }}>
                                              <Button
                                                sx={{
                                                  backgroundColor: row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice ? '#FF5C39' : '',
                                                  color: row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice ? '#FFF' : '#FF5C39',
                                                  '&:hover': {
                                                    backgroundColor: row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice ? '#FF7043' : '',
                                                  },
                                                  padding: '0.5rem 1rem',
                                                  borderRadius: '8px',
                                                  textTransform: 'none',
                                                  border: '1px solid #FF5C39',
                                                  width: '130px',
                                                }}
                                                onClick={() => {
                                                  setSelectedAuctionId(row.id);
                                                  setAuctionReservePrice(row.reservePrice);
                                                  toggleModal(true);
                                                }}
                                              >
                                                {row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice ? 'Increase Bid' : 'Update Bid'}
                                              </Button>
                                            </Grid>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </div>
                                  );
                                })
                              )}
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </>
            )
              : (
                <>
                  <FundsHeader funds={funds} />
                  {/* Auction Cards */}
                  <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 pt-6'>
                    {auctions?.Today && auctions?.Today?.length > 0 && auctions?.Today?.some(auction => auction?.county) ? (
                      auctions?.Today
                        .filter((auction) => auction.status !== false)
                        .map((auction, index) => {
                          const isLiveOrPaused = message[auction.id]?.auctionStatus === "Pause" || message[auction.id]?.auctionStatus === "Live" || message[auction.id]?.auctionRedoStatus === 2;
                          const isCountdownZero = countdowns[auction.id] === 0;
                          const isBelowReserve = auction.reservePrice != 0 && auction.proxyBidAmount < auction.reservePrice;
                          const hasPassedPreWindow = countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000;
                          const isAuctionNotLive = auction.auctionStatus !== "Live";
                          const baseClasses = 'p-2 rounded-md w-32 text-sm text-center flex justify-center cursor-pointer';
                          const buttonClassName =
                            isLiveOrPaused || isCountdownZero || (isBelowReserve && hasPassedPreWindow)
                              ? `${baseClasses} bg-[#FF5C39] text-white`
                              : (hasPassedPreWindow && isAuctionNotLive)
                                ? `${baseClasses} bg-[#FFF] border border-[#FF5C39] text-[#FF5C39]`
                                : 'p-2 bg-[#9FA4AB] rounded-[8px] w-32 text-white text-sm text-center flex justify-center';
                          return (
                            <div
                              key={index}
                              style={{ height: '100%', minHeight: '250px' }}
                              className={`${highlightedRows.includes(auction.id) ? 'highlight-flip p-4  w-full flex flex-col justify-between bg-white shadow-[0px_0px_8px_0px_#3B3B3B26] ' : 'p-4  w-full flex flex-col justify-between bg-white shadow-[0px_0px_8px_0px_#3B3B3B26]'}`}
                            >
                              <div>
                                <div
                                  className='text-sm font-medium'
                                  style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}
                                >
                                  {auction.address}
                                </div>
                                <div className='text-sm flex justify-between items-center mt-1'>
                                  <div>Proxy Bid Placed: <strong className='text-darkGray'> $<NumberFormatter amount={auction?.proxyBidAmount} /></strong></div>
                                  {
                                    (
                                      (message[auction.id]?.auctionStatus === "Live" || (countdowns[auction.id] === 0 && message[auction.id]?.auctionStatus !== "Closed"))
                                    ) && (
                                      <div className=' pr-1 border rounded-md bg-green-100 border-green-400 text-green-500 text-xs flex items-center'>
                                        <svg stroke="currentColor" fill="currentColor" aria-label="Bid placed" strokeWidth="0" viewBox="0 0 8 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                          <path fillRule="evenodd" d="M0 8c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4z"></path>
                                        </svg>
                                        Live
                                      </div>
                                    )
                                  }
  
                                </div>
                              </div>
                              <Divider sx={{ paddingTop: '6px' }} />
                              {
                                (message[auction.id]?.auctionStatus === "Live") ? (
                                  // ✅ LIVE BLOCK
                                  <>

                                    <div className={(message[auction.id]?.highestBidderId || auction?.highestBidderId) == investorId ? 'text-center pt-3 text-[#28A745] font-semibold text-[28px]' : 'text-center pt-3 text-[#3B3B3B] font-semibold text-[28px]'}>
                                      {message[auction.id]?.currentHighestBid ? ` $${message[auction.id]?.currentHighestBid?.toLocaleString() || auction.currentHighestBid?.toLocaleString()}` : "-"}
                                    </div>
                                    <div className='text-center text-[14px] font-semibold'>
                                      Current Highest Bid
                                    </div>
                                    {

                                      ((message[auction.id]?.currentHighestBid || auction?.currentHighestBid) !== 0 && message[auction?.id]?.message !== "") ? (
                                        <div className={`${message[auction.id]?.lastOutBiddedId == investorId ? 'text-[#EF233C]' : 'text-[#28A745]'} bg-[#F8F8F8] p-2 rounded-md text-[16px] text-center`}>
                                          {message[auction?.id]?.message}
                                        </div>
                                      ) : (
                                        <div className={"min-h-7"}>

                                        </div>
                                      )
                                    }
                                  </>
                                ) : (message[auction.id]?.auctionStatus === "Closed") ? (
                                  // ✅ CLOSED BLOCK
                                  message[auction.id]?.auctionRedoStatus === 2 ?

                                    <div className='flex justify-center items-center text-center mt-7 mb-7 text-sm h-full' aria-live="polite">
                                      <div>
                                        Auction starts in
                                      </div>
                                      <div className='w-[90px]'>
                                        <strong className='ml-1'>0h 0m 0s</strong>
                                      </div>
                                    </div> :
                                    <>
                                      <div className='text-center pt-3 text-[#3B3B3B] font-semibold text-[28px]'> {message[auction.id]?.currentHighestBid ? ` $${message[auction.id]?.currentHighestBid?.toLocaleString() || auction.currentHighestBid?.toLocaleString()}` : message[auction?.id]?.auctionResult === "FCLT_SoldBank" ? `$${auction?.reservePrice?.toLocaleString()}`
                                        : "-"}</div>
                                      <div className='text-center text-[14px] font-semibold'>{message[auction?.id]?.auctionResult !== "FCLT_SoldBank" ? "Winning Bid" : ""}</div>
                                      {message[auction?.id]?.message ? <div className={`${message[auction?.id]?.message === messageData.thirdParty || message[auction?.id]?.message === messageData.soldtobank ? "text-[#3b3b3b] bg-[#F8F8F8]" : 'text-[#28A745] bg-[#F8F8F8]'} p-2 rounded-md text-[16px] text-center`}>
                                        {message[auction?.id]?.message}
                                      </div> : <div className={"min-h-7"}>

                                      </div>}
                                    </>
                                ) : (message[auction.id]?.auctionStatus === "Pause") ? (
                                  // ✅ PAUSED BLOCK
                                  <div className='flex justify-center items-center text-center mt-7 mb-7 text-sm h-full' aria-live="polite">
                                    <div>Auction starts in</div>
                                    <div className='w-[90px]'>
                                      <strong className='ml-1'>0h 0m 0s</strong>
                                    </div>
                                  </div>
                                ) : (
                                  // ✅ DEFAULT COUNTDOWN BLOCK
                                  <div className='flex justify-center items-center text-center mt-7 mb-7 text-sm h-full' aria-live="polite">
                                    <div>Auction Starts in</div>
                                    <div className='w-[90px]'>
                                      <strong className='ml-1'>{formatCountdown(countdowns[auction.id])}</strong>
                                    </div>
                                  </div>
                                )
                              }


                              {auction.reservePrice != 0 &&
                                auction.proxyBidAmount < auction.reservePrice &&
                                countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000 && (
                                  <div className='flex justify-center items-center bg-[#F8F8F8] p-2 rounded-md mb-2'>
                                    <span className="text-red-500 text-sm">Proxy bid less than reserve price</span>
                                  </div>
                                )}
                              <div className='flex justify-center items-center w-full'>
                                {
                                  message[auction.id]?.auctionStatus !== "Closed" || message[auction.id]?.auctionRedoStatus === 2 ?
                                    <>
                                      <div
                                        data-testid={"auction-button"}
                                        onClick={() => {
                                          if (auction.reservePrice != 0 &&
                                            auction.proxyBidAmount < auction.reservePrice &&
                                            countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000) {
                                            setSelectedAuctionId(auction.id);
                                            setAuctionReservePrice(auction?.reservePrice)
                                            toggleModal(true);
                                          } else {
                                            if (countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000 && (message[auction.id]?.auctionStatus !== "Live" && message[auction.id]?.auctionStatus !== "Pause") && message[auction.id]?.auctionRedoStatus !== 2) {
                                              setSelectedAuctionId(auction.id);
                                              toggleModal(true);
                                              setAuctionReservePrice(auction?.reservePrice)
                                            }
                                            const isLive = message[auction.id]?.auctionStatus === "Live" || message[auction.id]?.auctionStatus === "Pause";
                                            const isCountdownFinished = countdowns[auction.id] === 0;

                                            if (isLive || isCountdownFinished || message[auction.id]?.auctionRedoStatus === 2) {
                                              handleNavigate(auction.id);
                                            }
                                          }
                                        }}
                                        className={buttonClassName}
                                      >

                                        {(countdowns[auction.id] >= auction?.preWindowClosingTimeFrame * 60 * 1000 && (message[auction.id]?.auctionStatus !== "Live" && message[auction.id]?.auctionStatus !== "Pause") && message[auction.id]?.auctionRedoStatus !== 2)
                                          ? (auction.reservePrice != 0 && auction.proxyBidAmount < auction.reservePrice)
                                            ? "Increase Bid"
                                            : "Update Bid"
                                          : "Live Auction"
                                        }

                                      </div>
                                    </> : (
                                      <div
                                        onClick={() => navigate(`/auctionpage/${auction?.propertyId}`)}
                                        className={'p-2 bg-[#FF5C39] rounded-md w-32 text-white text-sm text-center flex justify-center cursor-pointer'}
                                      >
                                        View Details
                                      </div>
                                    )
                                }
                              </div>
                            </div>
                          )
                        })
                    ) : (
                      <div className="col-span-full  bg-[#FCF8E3] p-3 flex justify-between items-center">
                        <div className='text-[#8A6D3B] text-[18px] font-[400]'>
                          You haven’t placed any proxy bids yet. Start exploring properties and secure your opportunities to bid effortlessly.
                        </div>

                        <div className='text-[#FF5C39] text-[20px] cursor-pointer' aria-label="Search" onClick={() => handleSearchNavigate()}>
                          <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                        </div>

                      </div>
                    )}
                  </div>


                  {/* Upcoming Auctions */}
                  <div className='mt-4 mb-4 font-semibold text-xl text-darkGray' role="heading" >Upcoming Auctions</div>
                  {/* Auction Table */}
                  <div className={getTotalLength(auctions) === 0 ? '' : 'bg-[#ffff] p-2 rounded shadow-custom-shadow-mybid'}>
                    <TableContainer className={getTotalLength(auctions) === 0 ? "" : "rounded-lg p-3 w-full lg:w-4/6"}>
                      {/* Check if there is any data in auctions */}
                      {getTotalLength(auctions) === 0 ? (
                        <div className="col-span-full  bg-[#FCF8E3] p-3 flex justify-between items-center">
                          <div className='text-[#8A6D3B] text-[18px] font-[400]'>
                            You haven’t placed any proxy bids yet. Start exploring properties and secure your opportunities to bid effortlessly.
                          </div>

                          <div className='text-[#FF5C39] text-[20px] cursor-pointer' aria-label="Search" role="button" onClick={() => handleSearchNavigate()}>
                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                          </div>

                        </div>
                      ) : (
                        <Table role="presentation">
                          <TableHead className="bg-[#F6F6F6]">
                            <TableRow>
                              <TableCell sx={{ fontWeight: '600', color: '#3b3b3b', textWrap: "nowrap", minWidth: "220px" }} className="font-bold">Property Address</TableCell>
                              <TableCell sx={{ fontWeight: '600', color: '#3b3b3b', textWrap: "nowrap" }} className="font-semibold">County</TableCell>
                              <TableCell sx={{ fontWeight: '600', color: '#3b3b3b', textWrap: "nowrap" }} className="font-semibold">Reserve Price</TableCell>
                              <TableCell sx={{ fontWeight: '600', color: '#3b3b3b', textWrap: "nowrap" }} className="font-semibold">Proxy Bid</TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: '600',
                                  color: '#3b3b3b',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  textWrap: "nowrap",
                                  '&:hover': { opacity: 0.8 }
                                }}
                                className="font-semibold "
                                onClick={handleSort}
                                aria-label="Sort by auction time"
                              >
                                Auction Time
                                <span className="ml-1 ">
                                  {sortDirection === 'ascending' ? <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg" aria-label="Sort by auction time ascending"><path d="M11 9H20V11H11zM11 13H18V15H11zM11 5H22V7H11zM11 17H16V19H11zM5 20L7 20 7 8 10 8 6 4 2 8 5 8z"></path></svg> : <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg" aria-label="Sort by auction time descending"><path d="M6 20L10 16 7 16 7 4 5 4 5 16 2 16zM11 8H20V10H11zM11 12H18V14H11zM11 4H22V6H11zM11 16H16V18H11z"></path></svg>}
                                </span>
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Object.keys(getSortedData(auctions))
                              .filter(key => key !== 'Today' && key !== 'Closed')
                              .map(key =>
                                getSortedData(auctions)[key].map((row, index) => {
                                  // Parse proxyAddedDate (in UTC)
                                  const proxyAddedDateUTC = new Date(row.proxyAddedDate);

                                  // Convert proxyAddedDate to local time
                                  const proxyAddedDateLocal = new Date(proxyAddedDateUTC.getTime() - proxyAddedDateUTC.getTimezoneOffset() * 60000);

                                  // Get current local time
                                  const currentLocalTime = new Date();

                                  // Calculate the time difference in milliseconds
                                  const timeDifference = currentLocalTime - proxyAddedDateLocal;

                                  // Check if the difference is <= 30 minutes (1,800,000 ms)
                                  const isHighlighted = timeDifference >= 0 && timeDifference <= 60000;

                                  // Alternating row colors (index % 2 === 0 for #FFFFFF, else #FCFCFC)
                                  const rowColor = index % 2 === 0 ? '#FFFFFF' : '#FCFCFC';
                                  const borderClass = rowColor === '#FCFCFC' ? 'border border-[#C5C9CD]' : '';

                                  const regex = /([+-]\d{2}:\d{2})$/;


                                  return (
                                    <StyledTableRow
                                      key={`${key}-${index}`}
                                      className={`${highlightedRows.includes(row.id) ? 'highlight-flip' : ''}`}
                                    // sx={{ backgroundColor: rowColor }}
                                    >
                                      <TableCell sx={{ color: '#3B3B3B', fontWeight: 600, fontSize: '14px', }}>{row.address}</TableCell>
                                      <TableCell sx={{ color: '#3B3B3B', fontWeight: 600 }}>{row.county}</TableCell>
                                      <TableCell sx={{ color: '#3B3B3B', fontWeight: 600 }}>${row.reservePrice?.toLocaleString()}</TableCell>
                                      <TableCell>
                                        <div style={{ color: '#3B3B3B', fontWeight: 600 }} className='font-semibold'>${row.proxyBidAmount?.toLocaleString()}</div>
                                        {row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice && (
                                          <span className="text-red-500 text-xs font-[600]">Proxy bid less than reserve price</span>
                                        )}
                                      </TableCell>
                                      <TableCell sx={{ color: '#3B3B3B', fontWeight: 600 }}>
                                        {new Date(row?.srpSaleDateTime?.replace(/([+-]\d{2}:\d{2})$/, ''))?.toLocaleString('en-US', {
                                          year: 'numeric',
                                          month: 'short',
                                          day: '2-digit',
                                          hour: 'numeric',
                                          minute: '2-digit',
                                          hour12: true,
                                        })}
                                      </TableCell>
                                      <TableCell>
                                        <Button
                                          sx={{
                                            backgroundColor: row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice ? '#FF5C39' : '',
                                            color: row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice ? '#FFF' : '#FF5C39',
                                            '&:hover': {
                                              backgroundColor: row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice ? '#FF7043' : '',
                                            },
                                            padding: '0.5rem 1rem',
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            border: '1px solid #FF5C39',
                                            width: '130px',
                                          }}
                                          onClick={() => {
                                            setSelectedAuctionId(row.id);
                                            setAuctionReservePrice(row.reservePrice);
                                            toggleModal(true);
                                          }}
                                        >
                                          {row.reservePrice != 0 && row.proxyBidAmount < row.reservePrice ? 'Increase Bid' : 'Update Bid'}
                                        </Button>
                                      </TableCell>
                                    </StyledTableRow>
                                  );
                                })
                              )}
                          </TableBody>
                        </Table>
                      )}
                    </TableContainer>
                  </div>
                </>
              )}

            <ProxyBidModal purchaseProfiles={purchaseProfiles} auctionReservePrice={auctionReservePrice} investorId={investorId} setLoading={setLoading} loading={loading} auctionId={selectedAuctionId} isOpen={isModalOpen} setIsModalOpen={setIsModalOpen} toggleModal={toggleModal} />
          </div>
        </div>
      </>
  );
};

export default MyBids;
